import { createReducer, on } from '@ngrx/store';

import { initialState } from '../../domain/constants/productsArray.constants';

import { ClearProductsArray } from './productsArray-commands.actions';
import { LoadProductsArraySuccess } from './productsArray-events.actions';

export const ProductsArrayReducer = createReducer(
    initialState,

    on(LoadProductsArraySuccess, (state, payload) => {
        return {
            ...state,
            products: {
                ...state.products,
                ...payload.productsArray,
            },
        };
    }),
    on(ClearProductsArray, () => {
        return initialState;
    }),
);
